import axios from 'axios';

export default (getOptions) => ({
    Subscribe: (id, data) => axios.post(`/api/mailchimp/subscribe/${id}`, data, getOptions()),
});
